import React, { useEffect, useState, useRef } from 'react'
const ActivityMenu = (props) => {
  const {
    lessonName,
    isSideMenuOpen,
    activityList,
    ContentID,
    imageFile,
    onLessonClick,
    onActivityClick,
    onOutsideClick,
    isSmartCanvas
  } = props

  const [closeSideMenu, setCloseSideMenu] = useState(true)
  const [isSideMenuClicked, setIsSideMenuClicked] = useState(false)

  useEffect(() => {
    if (isSideMenuOpen) {
      setIsSideMenuClicked(true)
      setCloseSideMenu(false)
    } else {
      if (isSideMenuClicked) {
        setTimeout(() => {
          setCloseSideMenu(true)
        }, 500)
      }
    }
  }, [isSideMenuOpen])

  useEffect(() => {
    if (isSideMenuClicked) {
      setIsSideMenuClicked(true)
    }
  }, [isSideMenuClicked])

  function renderActivitiesList(exercise, index) {
    return (
      <div
        key={'activityMenuItem' + index}
        className={
          isSmartCanvas
            ? ContentID === exercise.SlideID
              ? 'activity-item-container selected'
              : 'activity-item-container'
            : ContentID === exercise.ContentID
            ? 'activity-item-container selected'
            : 'activity-item-container'
        }
        onClick={() => {
          onActivityClick(index)
          onOutsideClick()
        }}
      >
        <img
          alt='icon'
          className='menu-item-image'
          src={
            isSmartCanvas
              ? exercise.AppName === 'SmartLabel'
                ? ContentID === exercise.SlideID
                  ? imageFile.smart_label_icon_selected
                  : imageFile.smart_label_icon
                : exercise.AppName === 'SmartPaper'
                ? ContentID === exercise.SlideID
                  ? imageFile.smart_paper_icon_selected
                  : imageFile.smart_paper_icon
                : exercise.AppName === 'SmartTiles'
                ? ContentID === exercise.SlideID
                  ? imageFile.smart_tile_icon_selected
                  : imageFile.smart_tile_icon
                : ContentID === exercise.SlideID
                ? imageFile.smart_slide_icon_selected
                : imageFile.smart_slide_icon
              : exercise.AppName === 'SmartLabel'
              ? ContentID === exercise.ContentID
                ? imageFile.smart_label_icon_selected
                : imageFile.smart_label_icon
              : exercise.AppName === 'SmartPaper'
              ? ContentID === exercise.ContentID
                ? imageFile.smart_paper_icon_selected
                : imageFile.smart_paper_icon
              : exercise.AppName === 'SmartTiles'
              ? ContentID === exercise.ContentID
                ? imageFile.smart_tile_icon_selected
                : imageFile.smart_tile_icon
              : ContentID === exercise.ContentID
              ? imageFile.smart_slide_icon_selected
              : imageFile.smart_slide_icon
          }
        />
        <p className='menu-item-label'>
          {isSmartCanvas ? exercise.SlideName : exercise.ContentName}
        </p>
      </div>
    )
  }

  return (
    <div
      className='menu-container'
      onClick={() => {
        onOutsideClick()
      }}
      style={{ display: closeSideMenu ? 'none' : 'flex' }}
    >
      <div
        className={
          isSideMenuOpen
            ? 'menu-list-container bounceInLeft'
            : 'menu-list-container bounceOutLeftMenu'
        }
      >
        <div className='heading-container'>
          <p
            className='heading-label'
            onClick={() => {
              // onLessonClick()
              onOutsideClick()
            }}
          >
            {lessonName}
          </p>
        </div>
        <div className='activities-container'>
          {activityList &&
            activityList.length > 0 &&
            activityList.map((exercise, index) => (
              <div className='activities-item-main'>
                {renderActivitiesList(exercise, index)}
                {exercise.ContainedView && isSmartCanvas && (
                  <div className='activities-cv-main'>
                    {exercise.ContainedView.length > 0 &&
                      exercise.ContainedView.map(
                        (containedExercise, containedIndex) => (
                          <div className='activities-item-main'>
                            {renderActivitiesList(
                              containedExercise,
                              containedIndex
                            )}
                          </div>
                        )
                      )}
                  </div>
                )}
              </div>
            ))}
        </div>
      </div>
    </div>
  )
}

export { ActivityMenu }
